export const SOCIAL_LINKS = {
    website: "https://www.daemons.app/",
    twitter: "https://x.com/daemons_gamefi",
    discord: "https://discord.gg/fVqxPyzCT6"
};